import React, { useEffect, useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import DataTable from "react-data-table-component";
import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";
import * as XLSX from "xlsx";
import authService from "../../../services/authService";
export default function CrudTable({
  data,
  onEdit,
  onEditLink,
  onDelete,
  onToggleStatus,
    onToggleAdvertised,
  onToggleApprovedStatus,
    onDeleteAdvertisement,

    onTogglePrescription,
      selectedIds = [],
  onSelectOne,
  hideCheckbox,
  onSelectAll,
  columns,
}) {
  const navigate = useNavigate();
  const location = useLocation();
  const currentPath = location.pathname;
  const isAdvertisementPage =
  currentPath === "/admin/advertise-section-products";
 const currentUser = authService.getCurrentUser();

const userRoleSlug = currentUser?.role?.slug;
const isTeleCaller = userRoleSlug === "tele-caller";
// Roles that should NOT see the Actions column
const restrictedActionRoles = [
  "tele-caller",
  "account-manager",
];

const isRestrictedRole = restrictedActionRoles.includes(userRoleSlug);
  // SEARCH STATES
  const [searchText, setSearchText] = useState("");

  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");

  const [openDropdownId, setOpenDropdownId] = useState(null);


  const handleSettingsClick = (id) => {
    setOpenDropdownId(openDropdownId === id ? null : id);
  };

  const handleNavigateToGallery = (id) => {
    navigate(`/admin/product-image-gallery/${id}`);
  };

  const isProductGalleryPage = currentPath.startsWith(
    "/admin/product-image-gallery"
  );


  const handleNavigateToProductReview = (id) => {
    navigate(`/admin/product-review/${id}`);
  };

  useEffect(() => {
    const tooltipTriggerList = document.querySelectorAll('[data-bs-toggle="tooltip"]');
    const tooltips = Array.from(tooltipTriggerList).map((el) => {
      if (!el._tooltip) {
        return new window.bootstrap.Tooltip(el);
      }
      return el._tooltip;
    });
    return () => {
      tooltips.forEach((tooltip) => tooltip.dispose());
    };
  }, [data]);


  const orderPages = [
    "/admin/all-orders",
    "/admin/new-orders",
    "/admin/delivered-orders",
    "/admin/cancelled-orders",
    "/admin/pending-orders",
  ];

  const isOrderPage = orderPages.includes(currentPath);

  const filteredData =
    data?.filter((row) => {
      const matchesSearch = Object.values(row)
        .filter(v => v !== null && v !== undefined)
        .join(" ")
        .toLowerCase()
        .includes(searchText.toLowerCase());

      if (!isOrderPage) return matchesSearch;

      if (!row.created_at) return false;

      const rowDate = new Date(row.created_at);
      rowDate.setHours(0, 0, 0, 0);

      const start = startDate ? new Date(startDate) : null;
      const end = endDate ? new Date(endDate) : null;

      if (start) start.setHours(0, 0, 0, 0);
      if (end) end.setHours(23, 59, 59, 999);

      const matchesStart = start ? rowDate >= start : true;
      const matchesEnd = end ? rowDate <= end : true;

      return matchesSearch && matchesStart && matchesEnd;
    }) || [];




const formatHeading = (text) => {
  return text
    .replace(/_/g, " ")
    .split(" ")
    .map(
      (word) =>
        word.charAt(0).toUpperCase() + word.slice(1).toLowerCase()
    )
    .join(" ");
};

const columnWidths = {
  sl: "40px",
  invoice_id: "110px",
  user_name: "110px",
  transaction_id: "220px",
  city: "110px",
  name: "140px",
  thumb_image: "140px",
  order_status: "130px",
  payment_status: "130px",
  payment_method: "140px",
  payment_gateway: "140px",
  utr_number: "150px",
  auth_code: "130px",
  product_qty: "100px",
  amount: "100px",
  order_invoice: "110px",
  order_date: "120px",
  actions: "170px",

  // Advertisement columns
  offer_price: "100px",
  offer_start_date: "130px",
  offer_end_date: "130px",
};


  const formatDate = (date) => {
    if (!date) return "";
    return new Date(date).toLocaleDateString("en-GB", {
      day: "2-digit",
      month: "short",
      year: "numeric",
    });
  };

  const dateRangeText =
    startDate && endDate
      ? `Order Date: ${formatDate(startDate)} - ${formatDate(endDate)}`
      : startDate
        ? `Order Date: From ${formatDate(startDate)}`
        : endDate
          ? `Order Date: Until ${formatDate(endDate)}`
          : "Order Date: All Dates";


  const generateFileName = () => {
    // Extract the last part of the route, e.g., "all-products"
    const pathSegments = currentPath.split("/").filter(Boolean);
    const lastSegment = pathSegments[pathSegments.length - 1] || "report";

    // Optional: add date range for orders
    let datePart = "";
    if (isOrderPage && (startDate || endDate)) {
      const start = startDate ? formatDate(startDate) : "";
      const end = endDate ? formatDate(endDate) : "";
      datePart = start && end ? `-${start}-to-${end}` : `-${start || end}`;
    }

    // Clean filename: replace spaces or commas with hyphens
    const safeName = `${lastSegment}${datePart}`
      .replace(/[^a-z0-9-]/gi, "-")
      .toLowerCase();

    return safeName;
  };



  // const downloadPDF = () => {
  //   const doc = new jsPDF();

  //   // Title
  //   doc.setFontSize(14);
  //   doc.text("Orders Report", 14, 15);

  //   // Date Range
  //   doc.setFontSize(10);
  //   doc.text(dateRangeText, 14, 22);

  //   autoTable(doc, {
  //     startY: 28,
  //     head: [columns.map(col => col.toUpperCase())],
  //     body: filteredData.map(item =>
  //       columns.map(col => item[col])
  //     ),
  //   });

  //   doc.save("orders-report.pdf");
  // };
  const downloadPDF = () => {
    const doc = new jsPDF();

    doc.setFontSize(14);
    doc.text("Report", 14, 15);

    doc.setFontSize(10);
    doc.text(dateRangeText, 14, 22);

    autoTable(doc, {
      startY: 28,
      head: [columns.map((col) => col.toUpperCase())],
      body: filteredData.map((item) => columns.map((col) => item[col])),
    });

    doc.save(`${generateFileName()}.pdf`);
  };




  // const downloadExcel = () => {
  //   const worksheetData = [
  //     [dateRangeText],
  //     [],
  //     columns.map(col => col.toUpperCase()),
  //     ...filteredData.map(item =>
  //       columns.map(col => item[col])
  //     ),
  //   ];

  //   const worksheet = XLSX.utils.aoa_to_sheet(worksheetData);
  //   const workbook = XLSX.utils.book_new();

  //   XLSX.utils.book_append_sheet(workbook, worksheet, "Orders");

  //   XLSX.writeFile(workbook, "orders-report.xlsx");
  // };


  const downloadExcel = () => {
    const worksheetData = [
      [dateRangeText],
      [],
      columns.map((col) => col.toUpperCase()),
      ...filteredData.map((item) => columns.map((col) => item[col])),
    ];

    const worksheet = XLSX.utils.aoa_to_sheet(worksheetData);
    const workbook = XLSX.utils.book_new();

    XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet1");

    XLSX.writeFile(workbook, `${generateFileName()}.xlsx`);
  };

const selectColumn = {
  name: " " ,
    cell: (row) => (
    <input
      type="checkbox"
      checked={
        data.length > 0 &&
        selectedIds.length === data.length
      }
      onChange={onSelectAll}
    />
  ),
  cell: (row) => (
    <input
      type="checkbox"
      checked={selectedIds.includes(row.id)}
      onChange={() => onSelectOne(row.id)}
    />
  ),
  width: "70px",
  ignoreRowClick: true,
  allowOverflow: true,
};
const hideCheckboxFor = [
  "/admin/sliders",
    "/admin/brands",
    "/admin/home-section-products",
    "/admin/transactions" ,
    "/admin/customer-management",
    "/admin/shipping-rule",
    "/admin/advertise-section-products",
    "/admin/user-management",
    "/admin/contact-us-list",
     "/admin/product-image-gallery",
  

];

const shouldShowCheckbox = !hideCheckboxFor.some((path) =>
  currentPath.startsWith(path)
);

// Hide Approval column for Tele Caller
const visibleColumns = isTeleCaller
  ? columns.filter((col) => col !== "is_approved")
  : columns;


const tableColumns = [
  ...(isOrderPage || !shouldShowCheckbox || hideCheckbox
    ? []
    : [selectColumn]),

  ...visibleColumns.map((col) => {
    const width = columnWidths[col];
if (col === "is_prescription") {
  return {
    name: "PRESCRIPTION",
    cell: (row) => (
      <div className="form-check form-switch">
        <input
          type="checkbox"
          className="form-check-input"
          checked={!!row.is_prescription}
          onChange={() =>
            onTogglePrescription && onTogglePrescription(row)
          }
        />
      </div>
    ),
    sortable: true,
     width: "160px",  
    wrap: true,
  };
}


if (col === "is_advertised") {
  // Advertisement Products page
  if (isAdvertisementPage) {
    return {
      name: "Delete",
      cell: (row) => (
        <button
          type="button"
          className="btn btn-sm btn-danger"
          onClick={() =>
            onDeleteAdvertisement &&
            onDeleteAdvertisement(row)
          }
          title="Delete Advertisement"
        >
          <i className="bx bx-trash"></i>
        </button>
      ),
      sortable: false,
      width: "100px",
      wrap: true,
    };
  }

  // Other pages - keep existing Advertisement toggle
  return {
    name: "Advertisement",
    cell: (row) => (
      <div className="form-check form-switch">
        <input
          type="checkbox"
          className="form-check-input"
          checked={!!row.is_advertised}
          onChange={() =>
            onToggleAdvertised &&
            onToggleAdvertised(row)
          }
        />
      </div>
    ),
    sortable: true,
    width: "120px",
    wrap: true,
  };
}

    if (col === "status") {
      return {
        name: "Status",
        cell: (row) => (
          <div className="form-check form-switch">
            <input
              type="checkbox"
              className="form-check-input"
              checked={!!row.status}
              onChange={() => onToggleStatus && onToggleStatus(row)}
            />
          </div>
        ),
        sortable: true,
        width,
          wrap: true,
      };
    }

    // Toggle button for Customer Active Status
    if (col === "is_active") {
      return {
        name: "Is Active",
        cell: (row) => (
          <div className="form-check form-switch">
            <input
              type="checkbox"
              className="form-check-input"
              checked={!!row.is_active}
              onChange={() => onToggleStatus && onToggleStatus(row)}
              aria-label={`Toggle active status for ${row.username || "customer"}`}
            />
          </div>
        ),
        sortable: true,
        width: "120px",
          wrap: true,
      };
    }


    if (col === "show_at_home") {
      return {
        name: "SHOW AT HOME",
        cell: (row) => (
          <div className="form-check form-switch">
            <input
              type="checkbox"
              className="form-check-input"
              checked={!!row.show_at_home}
              onChange={() =>
                onToggleApprovedStatus && onToggleApprovedStatus(row)
              }
            />
          </div>
        ),
        sortable: true,
        width: "150px",
          wrap: true,
      };
    }

    if (col === "is_approved") {
      return { 
        name: "Approval",
        cell: (row) => (
          <select
            className="form-select form-select-sm"
            value={row.is_approved ? "approved" : "pending"}
            onChange={(e) =>
              onToggleApprovedStatus &&
              onToggleApprovedStatus(row, e.target.value)
            }
            style={{ minWidth: "100px", fontSize: "12px" }}
          >
            <option value="pending">Pending</option>
            <option value="approved">Approved</option>
          </select>
        ),
        sortable: true,
         width: "160px",  
    wrap: true,
      };
    }

    if (col === "is_default") {
      return {
        name: "DEFAULT",
        cell: (row) => {
          const isDefault = row[col] === 1 || row[col] === true;

          return (
            <div
              style={{
                backgroundColor: isDefault ? "#D1FAE5" : "#FECACA",
                color: isDefault ? "#FB6C22" : "#991B1B",
                padding: "4px 8px",
                borderRadius: "15px",
                fontSize: "12px",
                fontWeight: "bold",
                textAlign: "center",
              }}
            >
              {isDefault ? "Default" : "No"}
            </div>
          );
        },
        sortable: true,
        width,
          wrap: true,
      };
    }

    if (col === "is_featured") {
      return {
        name: "FEATURED",
        cell: (row) => {
          const isFeatured = row[col] === 1 || row[col] === true;
          return (
            <div
              style={{
                backgroundColor: isFeatured ? "#D1FAE5" : "#FECACA",
                color: isFeatured ? "#FB6C22" : "#991B1B",
                padding: "6px 18px",
                borderRadius: "15px",
                fontSize: "12px",
                fontWeight: "bold",
                textAlign: "center",
              }}
            >
              {isFeatured ? "Yes" : "No"}
            </div>
          );
        },
        sortable: true,
        width,
          wrap: true,
      };
    }

   if (
  col === "logo" ||
  col === "banner" ||
  col === "blog_image" ||
  col === "brand_logo" || 
  col === "brand_image" ||
  col === "thumb_image" ||
  col === "category_image" ||
  col === "sub_category_image" ||
  col === "image"

  

) {
  return {
    name: col
      .split("_")
       .map((word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
      .join(" "),
           width: "140px",
  wrap: true,
        cell: (row) =>
          row[col] ? (
            <img
              src={
                row[col].startsWith("http")
                  ? row[col]
                  : `${process.env.REACT_APP_BASE_IMAGE_URL}/${row[col]}`
              }
              alt={col}
            style={{
  width: "70px",
  height: "45px",
  objectFit: "contain",
  display: "block",
  margin: "auto",
}}
            />
          ) : (
            "No Image"
          ),
        sortable: false,
      };
    }

   return {
  name:
    col === "product_type"
      ? "Type"
      : formatHeading(col),
      cell: (row) => {
        let value = row[col];
 // Format DOB as DD/MM/YYYY
if (col === "dob" && value) {
  const date = new Date(value);  
  
  const day = String(date.getDate()).padStart(2, "0");
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const year = date.getFullYear();

  value = `${day}/${month}/${year}`;
}
        if (col === "product_type") {
          if (!value || typeof value !== "string" || value.trim() === "") {
            return (
              <div
                style={{
                  backgroundColor: "#000",
                  color: "#fff",
                  padding: "4px 8px",
                  borderRadius: "4px",
                  fontSize: "12px",
                }}
              >
                None
              </div>
            );
          }

          let label = value
            .split(/[\s_]+/)
            .map(
              (word) =>
                word.charAt(0).toUpperCase() + word.slice(1).toLowerCase()
            )
            .join(" ");

          return (
            <div
              style={{
                backgroundColor: "#E5E7EB",
                color: "#030303",
                padding: "4px 8px",
                borderRadius: "4px",
                fontSize: "12px",
              }}
            >
              {label}
            </div>
          );
        }

        if (value && typeof value === "string") {
          value = value
            .split(/[\s_]+/)
            .map(
              (word) =>
                word.charAt(0).toUpperCase() + word.slice(1).toLowerCase()
            )
            .join(" ");
        }

       return (
  <div
    style={{
      width: "100%",
      textAlign: "center",
      wordBreak: "break-word",
      fontSize: "12px",
      lineHeight: "18px",
    }}
  >
    {value}
  </div>
);
      },
      sortable: true,
       width: width,
  wrap: true,
    };
  })
];

  // Hide ACTIONS column on these pages
  const hideActionsFor = [
    "/admin/customer-management",
    "/admin/transactions",
    "/admin/contact-us-list",
    "/admin/product-review",
      "/admin/advertise-section-products", 

  ];
  // const shouldShowActions = !hideActionsFor.includes(currentPath);
const shouldShowActions =
  !isRestrictedRole &&
  !hideActionsFor.some(path =>
    currentPath.startsWith(path)
  );

  const onView = (row) => {
    navigate(`/admin/order/${row.id}`);
  };

  //  Add Actions Column Only If Allowed
  if (shouldShowActions) {
    tableColumns.push({
      name: "Actions",
      cell: (row) => (
      <div
  className="d-flex justify-content-center align-items-center gap-1 position-relative"
  style={{
    width:"100%",
  }}
>

          {[
            "/admin/all-orders",
            "/admin/new-orders",  
            "/admin/delivered-orders",
            "/admin/cancelled-orders",
            "/admin/pending-orders",

          ].includes(currentPath) ? (
            <button
              onClick={() => onView(row)}
              className="btn btn-sm btn-primary"
              title="View"
            >
              <i className="bx bx-show"></i>
            </button>
          ) : (
            <>
              {/* <button
                onClick={() => onEdit(row)}
                className="btn btn-sm btn-primary me-2"
                title="Edit"
              >
                <i className="bx bx-edit"></i>
              </button> */}
              {/* Hide Edit Button on Product Image Gallery Page */}
              {!isProductGalleryPage && (
                <>
                  {onEditLink ? (
                 <a
  href={onEditLink(row)}
  className="btn btn-sm btn-primary me-2"
  title="Edit"
>
  <i className="bx bx-edit"></i>
</a>
                  ) : (
                    <button
                      onClick={() => onEdit(row)}
                      className="btn btn-sm btn-primary me-2"
                      title="Edit"
                    >
                      <i className="bx bx-edit"></i>
                    </button>
                  )}
                </>
              )}



              <button
                onClick={() => onDelete(row.id)}
                className="btn btn-sm btn-danger me-2"
                
                title="Delete"
              >
                <i className="bx bx-trash"></i>
              </button>
            </>
          )}

          {[
            "/admin/all-products",
            "/admin/active-products",
            "/admin/inactive-products",
          ].includes(currentPath) && (
              <div className="dropdown">
                <button
                  className="btn btn-sm btn-secondary"
                  onClick={() => handleSettingsClick(row.id)}
                  title="Settings"
                >
                  <i className="bx bx-cog"></i>

                </button>
                {openDropdownId === row.id && (
                  <div className="dropdown-menu show" style={{ top: "-80px", right: "20px", }}>
                    {/* <button
                      className="dropdown-item"
                      onClick={() => handleNavigateToGallery(row.id)}
                    >
                      Image Gallery
                    </button> */}
                    <a
                    href={`/admin/product-image-gallery/${row.id}`}
                    className="dropdown-item"
                  >
                    Image Gallery
                  </a>
                    <button
                      className="dropdown-item"
                      onClick={() => handleNavigateToProductReview(row.id)}
                    >
                      Product Review
                    </button>
                  </div>
                )}
              </div>
            )}
        </div>
      ),
      width: columnWidths.actions,
    });
  }

const customStyles = {
  table: {
    style: {
      borderRadius: "8px",
      overflow: "hidden",
      border: "1px solid #e5e7eb",
      backgroundColor: "#fff",
    },
  },

  headRow: {
    style: {
      minHeight: "42px",
      height: "42px",
      backgroundColor: "#FB6C22",
      color: "#fff",
      fontWeight: "700",
      fontSize: "12px",
    },
  },

  headCells: {
    style: {
      height: "42px",
      minHeight: "42px",
      paddingLeft: "8px",
      paddingRight: "8px",

      display: "flex",
      alignItems: "center",
      justifyContent: "center",

      textAlign: "center",
      whiteSpace: "normal",
      overflow: "hidden",
      textOverflow: "ellipsis",

      lineHeight: "15px",
    },
  },

 rows: {
  style: {
    minHeight: "48px",
    height: "auto",
    fontSize: "13px",
    color: "#333",

    borderBottom: "1px solid #f1f1f1",

    "&:hover": {
      backgroundColor: "#fff7f2",
    },
  },
},
 cells: {
  style: {
    paddingLeft: "8px",
    paddingRight: "8px",

    display: "flex",
    alignItems: "center",
    justifyContent: "center",

    textAlign: "center",

    whiteSpace: "normal",
    wordBreak: "break-word",
    overflowWrap: "break-word",

    lineHeight: "18px",

    minHeight: "48px",
    height: "auto",
    overflow: "visible",
  },
},

  pagination: {
    style: {
      borderTop: "1px solid #e5e7eb",
      minHeight: "42px",
      height: "42px",
    },
  },
};

  const hideExportButtonsFor = ["/admin/sliders"];
  const shouldShowExportButtons = !hideExportButtonsFor.includes(currentPath);
  const isProductPage = [
  "/admin/all-products",
  "/admin/active-products",
  "/admin/inactive-products",
  "/admin/all-sold-products",
  "/admin/all-offers-products"
].includes(currentPath);



  return (
    <>


{/* ================= ORDER CONTROLS ================= */}
{isOrderPage ? (
  <div
    className="d-flex flex-column flex-lg-row justify-content-between align-items-stretch align-items-lg-center gap-3 mb-3"
  >
    {/* LEFT SIDE - DATE FILTERS + SEARCH */}
    <div
      className="d-flex flex-column flex-md-row align-items-stretch align-items-md-center gap-2"
      style={{
        flex: "1",
      }}
    >
      {/* START DATE */}
      <input
        type="date"
        className="form-control text-dark"
        value={startDate}
        onChange={(e) => setStartDate(e.target.value)}
        style={{
          minWidth: "180px",
          maxWidth: "190px",
        }}
      />

      {/* END DATE */}
      <input
        type="date"
        className="form-control text-dark"
        value={endDate}
        onChange={(e) => setEndDate(e.target.value)}
        style={{
          minWidth: "180px",
          maxWidth: "190px",
        }}
      />

      {/* SEARCH */}
      <input
        type="text"
        placeholder="Search..."
        className="form-control"
        value={searchText}
        onChange={(e) => setSearchText(e.target.value)}
        style={{
          minWidth: "220px",
          maxWidth: "280px",
        }}
      />

      {/* CLEAR */}
      {(startDate || endDate) && (
        <button
          className="btn btn-outline-secondary"
          onClick={() => {
            setStartDate("");
            setEndDate("");
          }}
          style={{
            whiteSpace: "nowrap",
          }}
        >
          Clear
        </button>
      )}
    </div>

    {/* RIGHT SIDE - DOWNLOAD BUTTONS */}
    {shouldShowExportButtons && (
      <div
        className="d-flex flex-wrap gap-2 justify-content-lg-end"
        style={{
          flexShrink: 0,
        }}
      >
        <button
          className="btn btn-success"
          onClick={downloadExcel}
          style={{
            whiteSpace: "nowrap",
          }}
        >
          Download Excel
        </button>

        <button
          className="btn btn-danger"
          onClick={downloadPDF}
          style={{
            whiteSpace: "nowrap",
          }}
        >
          Download PDF
        </button>
      </div>
    )}
  </div>
) : (
  <>
    {/* ================= NON-ORDER PAGES ================= */}

    {/* EXPORT BUTTONS */}
    <div
      className="d-flex align-items-end justify-content-end"
      style={{
        margin: window.innerWidth <= 576 ? "0" : "-20px",
      }}
    >
      {shouldShowExportButtons && (
        <div
          className="d-flex flex-wrap gap-2"
          style={{
            position:
              window.innerWidth <= 576 ? "static" : "relative",
            top:
              window.innerWidth <= 576
                ? "0"
                : isProductPage
                ? "-2.0rem"
                : "-1.6rem",
            width:
              window.innerWidth <= 576 ? "100%" : "auto",
            flexDirection:
              window.innerWidth <= 576 ? "column" : "row",
            alignItems:
              window.innerWidth <= 576 ? "stretch" : "center",
            marginBottom:
              window.innerWidth <= 576 ? "12px" : "0",
          }}
        >
          <button
            className="btn btn-success"
            style={{
              width:
                window.innerWidth <= 576 ? "100%" : "auto",
              marginBottom:
                window.innerWidth <= 576 ? "8px" : "0",
            }}
            onClick={downloadExcel}
          >
            Download Excel
          </button>

          <button
            className="btn btn-danger"
            style={{
              width:
                window.innerWidth <= 576 ? "100%" : "auto",
              marginBottom:
                window.innerWidth <= 576 ? "8px" : "0",
            }}
            onClick={downloadPDF}
          >
            Download PDF
          </button>
        </div>
      )}
    </div>

    {/* SEARCH - NON ORDER PAGES */}
    <div
      className="d-flex flex-column flex-md-row align-items-stretch align-items-md-center justify-content-between gap-2 mb-3"
    >
      <div
        className="d-flex flex-column flex-md-row align-items-stretch align-items-md-center gap-2 ms-md-auto"
      >
        <input
          type="text"
          placeholder="Search..."
          className="form-control"
          style={{
            minWidth:
              window.innerWidth <= 576 ? "100%" : "220px",
            width:
              window.innerWidth <= 576 ? "100%" : "auto",
          }}
          value={searchText}
          onChange={(e) => setSearchText(e.target.value)}
        />
      </div>
    </div>
  </>
)}




      <DataTable
        columns={tableColumns}
        // data={data}
        data={filteredData}

        pagination
        highlightOnHover
        striped
        responsive
        customStyles={customStyles}
      />
     
    </>
  );
}
